module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"This is the remaining period of the free trial, please upgrade your plan to clear this message.","days":"Days","remaining":"Remaining"},"pt-BR":{"message":"Esse é o período restante do teste gratuito, faça o upgrade de plano para sumir essa mensagem.","days":"Dias","remaining":"Restantes"}}')
  delete Component.options._Ctor
}
